import React, { PureComponent, Fragment } from 'react';
import './Configurador.css';
import { translate } from '../../utils/translations';
import { DEFAULT_CONFIG, WIDGET_NAMES } from '../../utils/globals';
import Header from './Header';
import Footer from './Footer';
import { Wrapper } from './Wrapper';
import { Helmet } from 'react-helmet';

class Configurador extends PureComponent {
    state = {
        language: DEFAULT_CONFIG.language,
    };

    render() {
        return (
            <Fragment>
                <Helmet>
                    <title>
                        {translate(this.state.language, 'config_title')}
                    </title>
                </Helmet>
                <Header
                    language={this.state.language}
                    renderLanguageMenuItem={this.renderLanguageMenuItem}
                />
                <div className="mobile-message">
                    <h2 className="configurador__heading">
                        {translate(
                            this.state.language,
                            'config_heading_mobile'
                        )}
                    </h2>
                    <hr />
                    <p className="configurador__descriptions">
                        {translate(
                            this.state.language,
                            'config_description_mobile'
                        )}
                    </p>
                </div>
                <div className="configurador__wrapper">
                    <h2 className="configurador__heading">
                        {translate(this.state.language, 'config_heading')}
                    </h2>
                    <hr />
                    <p className="configurador__descriptions">
                        {translate(this.state.language, 'config_description')}
                    </p>
                    <Wrapper
                        language={this.state.language}
                        translationCode="8d"
                        widget="municipal8d"
                        form="form8d48h"
                    />
                    <Wrapper
                        language={this.state.language}
                        translationCode="72h"
                        widget={WIDGET_NAMES.municipal72h}
                        form="form8d48h"
                    />
                    <Wrapper
                        language={this.state.language}
                        translationCode="pred_general"
                        widget="mapaPrediccio"
                        form="formSimple"
                    />
                    <Wrapper
                        language={this.state.language}
                        translationCode="radar"
                        widget="mapaRadar"
                        form="formSimple"
                    />
                    <Wrapper
                        language={this.state.language}
                        translationCode="avisos"
                        widget="mapaAvisos"
                        form="formSimple"
                    />  

                    <Wrapper
                        language={this.state.language}
                        translationCode="aramet"
                        widget="mapaAramet"
                        form="formSimple"
                    />                    
                </div>
                <Footer language={this.state.language} />
            </Fragment>
        );
    }

    changeLanguage = language => this.setState({ language });

    renderLanguageMenuItem = (langCode, langName) => {
        const langMenuItem =
            this.state.language !== langCode ? (
                <li onClick={() => this.changeLanguage(langCode)}>
                    <span>{langName}</span>
                </li>
            ) : null;
        return langMenuItem;
    };
}

export default Configurador;



// WEBPACK FOOTER //
// ./src/containers/Configurador/Configurador.js